/* Landing.jsx — JAI marketing landing page (public '/welcome').
   Assembles the ported design-prototype sections and wires their callbacks to
   the real app: "Get started" → straight into the app, "Sign in" → /login, nav
   links → smooth-scroll, footer → legal pages.

   No longer the site's front door — '/' is the app itself. This page is here
   for the places that still want a pitch: campaign links, ads, search results.
   Its "Get started" therefore goes INTO the product rather than to a sign-up
   form, which is the same barrier this page stopped being. */

import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import '../styles/landing.css'
import { FONTS, LFooter } from '../components/landing/landingShared'
import {
  TopNav, V2Hero, V2Spotlight, V2Arsenal, V2HowScreens, V2About, V2Finale,
} from '../components/landing/LandingSections'

export default function Landing() {
  const navigate = useNavigate()

  useEffect(() => { window.scrollTo(0, 0) }, [])

  const scrollToId = (id) => {
    const el = document.getElementById(id)
    if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 62, behavior: 'smooth' })
  }

  // "Sign in" is for people who already have an account. Everything else —
  // "Get started", the hero and finale CTAs — drops them into the app, where a
  // guest session is created for them automatically.
  const onAuth = (mode) => navigate(mode === 'login' ? '/login' : '/')

  const onNav = (id) => {
    if (id === 'pricing') navigate('/pricing')
    else if (id === 'terms') navigate('/terms')
    else if (id === 'privacy') navigate('/privacy')
    else if (id === 'contact') scrollToId('about')
    else scrollToId(id) // features | how | about | arsenal
  }

  return (
    <div className="jai-landing" style={{ fontFamily: FONTS.tight, color: 'white', minHeight: 'calc(100vh / var(--jai-zoom))', position: 'relative' }}>
      <TopNav onNav={onNav} onAuth={onAuth} />
      <V2Hero onNav={onNav} onAuth={onAuth} />
      <V2Spotlight />
      <V2Arsenal />
      <V2HowScreens />
      <V2About />
      <V2Finale onAuth={onAuth} />
      <LFooter dark onNav={onNav} />
    </div>
  )
}
